import React, { Fragment } from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import SelectForm from '../../../../../components/form/SelectForm';
import InputForm from '../../../../../components/form/InputForm';
import SearchAddress from '../../../../../components/SearchAddress';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import { MAXIMUM_NUMBER_OF_INVOICE_NUMBER } from '../../../../../constants/service/common/utilConstants';
import {
  ORDER_ITEM_DELIVERY_TYPE_SEARCH_SELECT_LIST,
  ORDER_DELIVERY_TYPE,
  MAXIMUM_NUMBER_OF_SHIPPING_MESSAGE_TEXT,
} from '../../../../../constants/service/app/orderConstants';
import { setNumberWithComma, numberKeyPress, setPhoneFormat } from '../../../../../lib/common';
import { formRequiredRules } from '../../../../../lib/formRules';
import './RejectCancelDeliveryDispatchModal.scss';

const RejectCancelDeliveryDispatchModal = (props) => {
  const {
    isOpen,
    data,
    form,
    onSubmit,
    setData,
    closeModal,
    deliveryDispatchType,
    deliveryDispatchAgentId,
    deliveryInvoiceNumber,
    address,
    message,
    setAddressLine2,
  } = props;
  const { deliveryAgentList, orderItemId, productName, productPrice, buyerPhone, recipientPhone } = data;

  return (
    <Modal
      title="취소 거부 -> 발송 처리"
      isOpen={isOpen}
      width={660}
      height={600}
      isFooter={true}
      okText="발송 처리"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="delivery-dispatch-modal-wrap">
        <div className="delivery-dispatch-info">
          <div>* 함께 처리 가능한 상품 주문건이 모두 노출됩니다.</div>
        </div>

        <div className="delivery-dispatch-modal-table-title">취소 정보 확인</div>

        <InfoTable className="selected-order-item-list-table">
          <thead>
            <tr>
              <th>상품 주문번호</th>
              <th>상품명</th>
              <th>상품 가격(정가)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="tc">{orderItemId}</td>
              <td className="tc">{productName}</td>
              <td className="tc">{setNumberWithComma(productPrice, '원')}</td>
            </tr>
          </tbody>
        </InfoTable>

        <InfoTable className="delivery-dispatch-info-table">
          <tbody>
            <tr>
              <td className="tc label">배송방법</td>
              <td className="tl" colSpan={3}>
                <SelectForm
                  form={form}
                  name="deliveryDispatchType"
                  rules={[formRequiredRules(true, null, false)]}
                  list={ORDER_ITEM_DELIVERY_TYPE_SEARCH_SELECT_LIST}
                  initialValue={deliveryDispatchType}
                  size="default"
                  isTable={true}
                  onChange={(value) =>
                    setData({
                      name: 'deliveryDispatchType',
                      value,
                    })
                  }
                />
              </td>
            </tr>
            {deliveryDispatchType === ORDER_DELIVERY_TYPE.PARCEL_DELIVERY ? (
              <Fragment>
                <tr>
                  <td className="tc label">택배사</td>
                  <td className="tl" colSpan={3}>
                    <SelectForm
                      form={form}
                      name="deliveryDispatchAgentId"
                      rules={[formRequiredRules(true, null, false)]}
                      list={deliveryAgentList}
                      initialValue={deliveryDispatchAgentId}
                      size="default"
                      isTable={true}
                      onChange={(value) =>
                        setData({
                          name: 'deliveryDispatchAgentId',
                          value,
                        })
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td className="tc label">송장번호</td>
                  <td className="tl" colSpan={3}>
                    <InputForm
                      form={form}
                      name="deliveryInvoiceNumber"
                      rules={[formRequiredRules(true, null)]}
                      getValueFromEvent={(value) => value.replace(/[^0-9]/g, '')}
                      onKeyUp={(e) => numberKeyPress(e)}
                      initialValue={deliveryInvoiceNumber}
                      maxLength={MAXIMUM_NUMBER_OF_INVOICE_NUMBER}
                      onChange={(value) =>
                        setData({
                          name: 'deliveryInvoiceNumber',
                          value: value.replace(/[^0-9]/g, ''),
                        })
                      }
                    />
                  </td>
                </tr>
              </Fragment>
            ) : null}
            <tr>
              <td className="tc label">구매자 연락처</td>
              <td className="tl" colSpan={3}>
                <div>{setPhoneFormat(buyerPhone)}</div>
              </td>
            </tr>
            <tr>
              <td className="tc label">수취인 연락처</td>
              <td className="tl" colSpan={3}>
                <div>{setPhoneFormat(recipientPhone)}</div>
              </td>
            </tr>
            <tr>
              <td className="tc label">배송지</td>
              <td className="tl" colSpan={3}>
                <SearchAddress
                  address={address}
                  onSelect={(address) =>
                    setData({
                      name: 'address',
                      value: address,
                    })
                  }
                />
                <InputForm
                  form={form}
                  name="address-line2"
                  rules={[formRequiredRules(true, undefined, true)]}
                  initialValue={address.line2}
                  onChange={(value) => setAddressLine2(value)}
                  placeholder="상세 주소"
                />
              </td>
            </tr>
            <tr>
              <td className="tc label">배송메시지</td>
              <td className="tl" colSpan={3}>
                <TextAreaForm
                  form={form}
                  name="message"
                  initialValue={message}
                  onChange={(value) =>
                    setData({
                      name: 'message',
                      value,
                    })
                  }
                  maxLength={MAXIMUM_NUMBER_OF_SHIPPING_MESSAGE_TEXT}
                />
              </td>
            </tr>
          </tbody>
        </InfoTable>
      </div>
    </Modal>
  );
};

export default RejectCancelDeliveryDispatchModal;
